import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SchedulePricingComponent } from './schedule-pricing.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AppMaterialModule } from '../../../../../../../shared/appMaterial/app-material.module';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
  declarations: [SchedulePricingComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    AppMaterialModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatRadioModule,
  ],
  entryComponents: [SchedulePricingComponent],
})
export class SchedulePricingModule {}
